import React from "react";

import { NoCompany } from "@Core/components/Layouts";

const NoCompanyPage = () => {
  return <NoCompany />;
};

export default NoCompanyPage;
